import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';

import { Link, useParams } from 'react-router-dom'; 
import Sidebar from '../../Sidebar';
  


function PrivacyPolicy(){
    const [items, setItems] = useState([]);
    
    const pathSegments = window.location.pathname.split("/"); 
  const lastSegment = pathSegments[pathSegments.length - 1]; 
    const [isEnglish, setIsEnglish,getIsEnglish] = useState(sessionStorage.getItem("language_index") != null && sessionStorage.getItem("language_index") == 1);
    useEffect(() => {
     
      axios.get('/backend/home.php', {
        headers: {
            'Custom-type': 'service3',
            'Content-Type': 'application/json',  // Beispiel für Content-Type
            // Weitere Header können hier hinzugefügt werden
        }
    })
    .then(response => {
        setItems(response.data);
    })
    .catch(error => {
        console.error('Es gab einen Fehler beim Abrufen der Daten:', error);
    });
    
    }
    , []);// Leer, d.h. dieser Effekt wird nur einmal nach dem initialen Rendern ausgeführt

    useEffect(() => {
       LanguageChange();
      }, [items]);// Dieser Effekt wird nur ausgeführt, wenn sich `items` ändert
       const LanguageChange = () => {
              const languageIndex = sessionStorage.getItem("language_index");
           setIsEnglish(languageIndex != null && languageIndex == 1);
           var isEnglish=languageIndex != null && languageIndex == 1;
         var topic =    document.getElementById("topic_header");
          if (lastSegment === "cosmictap") {
               topic.innerText = isEnglish ?  "Privacy policy – CosmicTap" : "Datenschutzerklärung – CosmicTap";
          } else if (lastSegment === "drunkmaster") {
         topic.innerText = isEnglish ?  "Privacy policy – DrunkMaster" : "Datenschutzerklärung – DrunkMaster";
          } else if (lastSegment === "dontask") {
               topic.innerText = isEnglish ?  "Privacy policy – Don’t Ask" : "Datenschutzerklärung – Don’t Ask";
          }else if (lastSegment === "vulpio") {
               topic.innerText = isEnglish ?  "Privacy policy – Vulpio" : "Datenschutzerklärung – Vulpio";
          }
         
       }
const WhichPP = () => {
  if (lastSegment === "cosmictap") {
        return isEnglish ? <CosmicTapEN /> : <CosmicTapDE  />;
  } else if (lastSegment === "drunkmaster") {
    return isEnglish ? <DrunkmasterEN /> : <DrunkmasterDE />;
  } else if (lastSegment === "dontask") {
      return isEnglish ? <DontAskEN/> : <DontAskDE  />;
  } else if(lastSegment == "vulpio") {
    return isEnglish ? <VulpioEN/> : <VulpioDE  />;
  }else{
     return <div></div>;
  }
};

    const DrunkmasterDE = () => {
      return( <div>
 <p>Der Schutz Ihrer Daten ist uns wichtig. Nachfolgend informieren wir Sie über die Verarbeitung personenbezogener Daten bei der Nutzung unserer App <strong>DrunkMaster</strong> gemäß den Vorgaben der Datenschutz-Grundverordnung (DSGVO).</p>
            <h2>1. Verantwortlicher</h2>
    <p>Finn Mikoschek</p>

     <p>info@finnmikoschek.de</p>

    <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
    <p>Die App <strong>DrunkMaster</strong> erhebt oder verarbeitet <strong>keine personenbezogenen Daten</strong>. Es ist keine Registrierung oder Anmeldung erforderlich. Alle Funktionen der App können vollständig anonym genutzt werden.</p>

    <h2>3. Einbindung von Werbung (AdMob)</h2>
    <p>Zur Finanzierung der App wird Werbung durch den Dienst <strong>Google AdMob</strong> eingeblendet. AdMob kann bestimmte Daten (z. B. Geräteinformationen, IP-Adresse, Standort in grober Form) erfassen, um personalisierte oder nicht-personalisierte Werbung anzuzeigen.</p>
    <p>Weitere Informationen zur Datenverarbeitung durch Google finden Sie hier:
      <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">https://policies.google.com/technologies/partner-sites</a>
    </p>
    <p>Sie können personalisierte Werbung in den Einstellungen Ihres Geräts oder über Googles Werbeeinstellungen deaktivieren.</p>

    <h2>4. Keine Erstellung von Benutzerkonten</h2>
    <p>Die App bietet keine Möglichkeit zur Erstellung von Benutzerkonten. Es findet keine Speicherung oder Verarbeitung von Login-Daten statt.</p>

    <h2>5. Datenübermittlung in Drittländer</h2>
    <p>Durch die Nutzung von Google AdMob kann eine Übermittlung von Daten in Länder außerhalb der EU erfolgen. Google ist unter dem EU-U.S. Data Privacy Framework zertifiziert und verpflichtet sich zur Einhaltung eines angemessenen Datenschutzniveaus.</p>

    <h2>6. Ihre Rechte</h2>
    <p>Als Nutzer haben Sie nach der DSGVO folgende Rechte:</p>
    <ul>
      <li>Auskunft (Art. 15 DSGVO)</li>
      <li>Berichtigung (Art. 16 DSGVO)</li>
      <li>Löschung (Art. 17 DSGVO)</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
      <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
    </ul>
    <p>Da wir keine personenbezogenen Daten verarbeiten, können diese Rechte nur im Zusammenhang mit der Werbung durch Google AdMob geltend gemacht werden.</p>

    <h2>7. Kontakt</h2>
    <p>Bei Fragen zum Datenschutz wenden Sie sich bitte an die oben genannte Kontaktadresse.</p>
    <h2>1. Verantwortlicher</h2>
    <p>Finn Mikoschek</p>
    <p>info@finnmikoschek.de</p>

    <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
    <p>Die App <strong>DrunkMaster</strong> erhebt oder verarbeitet <strong>keine personenbezogenen Daten</strong>. Es ist keine Registrierung oder Anmeldung erforderlich. Alle Funktionen der App können vollständig anonym genutzt werden.</p>

    <h2>3. Einbindung von Werbung (AdMob)</h2>
    <p>Zur Finanzierung der App wird Werbung durch den Dienst <strong>Google AdMob</strong> eingeblendet. AdMob kann bestimmte Daten (z. B. Geräteinformationen, IP-Adresse, Standort in grober Form) erfassen, um personalisierte oder nicht-personalisierte Werbung anzuzeigen.</p>
    <p>Weitere Informationen zur Datenverarbeitung durch Google finden Sie hier:
      <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">https://policies.google.com/technologies/partner-sites</a>
    </p>
    <p>Sie können personalisierte Werbung in den Einstellungen Ihres Geräts oder über Googles Werbeeinstellungen deaktivieren.</p>

    <h2>4. Keine Erstellung von Benutzerkonten</h2>
    <p>Die App bietet keine Möglichkeit zur Erstellung von Benutzerkonten. Es findet keine Speicherung oder Verarbeitung von Login-Daten statt.</p>

    <h2>5. Datenübermittlung in Drittländer</h2>
    <p>Durch die Nutzung von Google AdMob kann eine Übermittlung von Daten in Länder außerhalb der EU erfolgen. Google ist unter dem EU-U.S. Data Privacy Framework zertifiziert und verpflichtet sich zur Einhaltung eines angemessenen Datenschutzniveaus.</p>

    <h2>6. Ihre Rechte</h2>
    <p>Als Nutzer haben Sie nach der DSGVO folgende Rechte:</p>
    <ul>
      <li>Auskunft (Art. 15 DSGVO)</li>
      <li>Berichtigung (Art. 16 DSGVO)</li>
      <li>Löschung (Art. 17 DSGVO)</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
      <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
    </ul>
    <p>Da wir keine personenbezogenen Daten verarbeiten, können diese Rechte nur im Zusammenhang mit der Werbung durch Google AdMob geltend gemacht werden.</p>

    <h2>7. Kontakt</h2>
    <p>Bei Fragen zum Datenschutz wenden Sie sich bitte an die oben genannte Kontaktadresse.</p>
      </div>
            
               );
    }

        const DrunkmasterEN = () => {
      return( <div>
        <p>Protecting your data is important to us. Below we inform you about the processing of personal data when using our app <strong>DrunkMaster</strong> in accordance with the General Data Protection Regulation (GDPR).</p>

<h2>1. Controller</h2>
<p>Finn Mikoschek</p>
<p>info@finnmikoschek.de</p>

<h2>2. Collection and Processing of Personal Data</h2>
<p>The app <strong>DrunkMaster</strong> does <strong>not collect or process any personal data</strong>. No registration or login is required. All functions of the app can be used completely anonymously.</p>

<h2>3. Integration of Advertising (AdMob)</h2>
<p>To finance the app, ads are displayed via the service <strong>Google AdMob</strong>. AdMob may collect certain data (e.g., device information, IP address, approximate location) to display personalized or non-personalized ads.</p>
<p>More information on data processing by Google can be found here:
  <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">https://policies.google.com/technologies/partner-sites</a>
</p>
<p>You can disable personalized ads in your device settings or through Google’s ad settings.</p>

<h2>4. No User Accounts</h2>
<p>The app does not offer the possibility to create user accounts. No storage or processing of login data takes place.</p>

<h2>5. Data Transfer to Third Countries</h2>
<p>By using Google AdMob, data may be transferred to countries outside the EU. Google is certified under the EU-U.S. Data Privacy Framework and commits to maintaining an adequate level of data protection.</p>

<h2>6. Your Rights</h2>
<p>As a user, you have the following rights under the GDPR:</p>
<ul>
  <li>Access (Art. 15 GDPR)</li>
  <li>Rectification (Art. 16 GDPR)</li>
  <li>Erasure (Art. 17 GDPR)</li>
  <li>Restriction of processing (Art. 18 GDPR)</li>
  <li>Data portability (Art. 20 GDPR)</li>
  <li>Objection to processing (Art. 21 GDPR)</li>
</ul>
<p>Since we do not process any personal data, these rights can only be asserted in connection with advertising by Google AdMob.</p>

<h2>7. Contact</h2>
<p>If you have any questions regarding data protection, please contact the address mentioned above.</p>
      </div>
            
               );
    }

    const DontAskEN = () => {
      return (<div>
        <p>We value your privacy. Below we explain how we handle personal data when using our app <strong>Don't Ask</strong>, in accordance with applicable data protection laws such as the EU General Data Protection Regulation (GDPR).</p>

    <h2>1. Controller</h2>
    <p>Finn Mikoschek</p>
    <p>info@finnmikoschek.de</p>

    <h2>2. Data Collection and Processing</h2>
    <p><strong>Don't Ask</strong> does <strong>not collect, store, or process any personal data</strong>. No registration or login is required. All features of the app can be used completely anonymously.</p>

    <h2>3. Advertising</h2>
    <p>Our app does <strong>not display any advertisements</strong>. No data is used for tracking, targeting, or advertising purposes.</p>

    <h2>4. In-App Purchases</h2>
    <p>The app offers optional question packs as in-app purchases. Payment processing is handled entirely by the platform provider (e.g., Apple App Store or Google Play Store). We do <strong>not receive or store any payment or user data</strong>.</p>

    <h2>5. International Data Transfers</h2>
    <p>Since we do not collect or process any personal data, there are no data transfers to third countries.</p>

    <h2>6. Your Rights</h2>
    <p>Under the GDPR and other international privacy laws, users generally have the following rights:</p>
    <ul>
      <li>Right of access (Art. 15 GDPR)</li>
      <li>Right to rectification (Art. 16 GDPR)</li>
      <li>Right to erasure (Art. 17 GDPR)</li>
      <li>Right to restriction of processing (Art. 18 GDPR)</li>
      <li>Right to data portability (Art. 20 GDPR)</li>
      <li>Right to object (Art. 21 GDPR)</li>
    </ul>
    <p>However, since <strong>we do not collect or process any personal data</strong>, these rights are not applicable in relation to the use of our app. For any rights related to purchases, please refer to the privacy policies of the respective app store platforms.</p>

    <h2>7. Contact</h2>
    <p>If you have any questions about this privacy policy, feel free to contact us at the address above.</p>
      </div>);
    }

    const DontAskDE = () => {

      return (<div>
        <p>Der Schutz Ihrer Daten ist uns wichtig. Nachfolgend informieren wir Sie über die Verarbeitung personenbezogener Daten bei der Nutzung unserer App <strong>Don't Ask</strong> gemäß den Vorgaben der Datenschutz-Grundverordnung (DSGVO).</p>

    <h2>1. Verantwortlicher</h2>
    <p>Finn Mikoschek</p>
    <p>info@finnmikoschek.de</p>

    <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
    <p>Die App <strong>Don't Ask</strong> erhebt oder verarbeitet <strong>keine personenbezogenen Daten</strong>. Es ist keine Registrierung oder Anmeldung erforderlich. Alle Funktionen der App können vollständig anonym genutzt werden.</p>

    <h2>3. Werbung</h2>
    <p>Die App enthält <strong>keine Werbung</strong>. Es erfolgt keinerlei Tracking oder Auswertung zu Werbezwecken.</p>

    <h2>4. In-App-Käufe</h2>
    <p>In der App können optionale Fragenpakete (In-App-Käufe) erworben werden. Die Zahlungsabwicklung erfolgt ausschließlich über die Plattform des jeweiligen App Stores (z. B. Apple App Store, Google Play Store). Wir erhalten keine Zahlungs- oder personenbezogenen Daten.</p>

    <h2>5. Datenübermittlung in Drittländer</h2>
    <p>Da keine personenbezogenen Daten durch uns erhoben oder verarbeitet werden, findet auch keine Datenübermittlung in Drittländer statt.</p>

    <h2>6. Ihre Rechte</h2>
    <p>Als Nutzer haben Sie nach der DSGVO folgende Rechte:</p>
    <ul>
      <li>Auskunft (Art. 15 DSGVO)</li>
      <li>Berichtigung (Art. 16 DSGVO)</li>
      <li>Löschung (Art. 17 DSGVO)</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
      <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
    </ul>
    <p>Da wir keine personenbezogenen Daten verarbeiten, können diese Rechte nur im Zusammenhang mit den App Stores und deren Abwicklung der In-App-Käufe geltend gemacht werden.</p>

    <h2>7. Kontakt</h2>
    <p>Bei Fragen zum Datenschutz wenden Sie sich bitte an die oben genannte Kontaktadresse.</p>
      </div>)
     }
    
    const CosmicTapDE = () => {
      return (<div> <section>
            <h2>1. Einleitung</h2>
            <p>Diese Datenschutzrichtlinie beschreibt, wie CosmicTap Daten sammelt, verwendet, verarbeitet und schützt, die während der Nutzung unserer mobilen App erhoben werden. Wir verpflichten uns, Ihre Privatsphäre zu schützen und die relevanten Datenschutzgesetze in Deutschland, einschließlich der Datenschutz-Grundverordnung (DSGVO), des Bundesdatenschutzgesetzes (BDSG) und des Telekommunikation-Telemedien-Datenschutz-Gesetzes (TTDSG), einzuhalten.</p>
        </section>
        <section>
            <h2>2. Verantwortlicher für den Datenschutz</h2>
            <p>Verantwortlich für die Verarbeitung der Daten im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
            <p>Finn Mikoschek</p>
              <p>  info@finnmikoschek.de
            </p>
        </section>
        <section>
            <h2>3. Welche Daten sammeln wir?</h2>
            <p>Wir sammeln Daten, um Ihnen unsere Dienste bereitzustellen, die App zu verbessern und gesetzliche Anforderungen zu erfüllen. Dies umfasst:</p>
            <h3>3.1 Automatisch gesammelte Daten:</h3>
            <ul>
                <li><strong>Geräteinformationen:</strong> Gerätetyp, Betriebssystem, Gerätemodell, eindeutige Gerätekennung (z. B. Advertising ID).</li>
                <li><strong>Nutzungsdaten:</strong> Interaktionen mit der App, Sitzungsdauer, Fehler- und Absturzberichte.</li>
            </ul>
            <h3>3.2 Daten durch Drittanbieter:</h3>
            <p>Wir nutzen Dienste von Drittanbietern wie Google AdMob (Werbung), Google Firebase (Analytics und Account-Management) und Zahlungsplattformen (Google Play Store/Apple App Store), die zusätzliche Daten sammeln können, darunter:</p>
            <ul>
                <li>Standortdaten (für personalisierte Werbung).</li>
                <li>Zahlungsdaten (wie Kaufbestätigungen, die ausschließlich durch die Stores verarbeitet werden).</li>
                <li><strong>Account-Daten:</strong> E-Mail-Adressen für die Erstellung von Accounts über Firebase, wenn Nutzer ihre Daten in der Cloud speichern möchten.</li>
            </ul>
        </section>
        <section>
            <h2>4. Rechtsgrundlagen der Datenverarbeitung</h2>
            <p>Wir verarbeiten personenbezogene Daten gemäß den folgenden Rechtsgrundlagen:</p>
            <ul>
                <li><strong>Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO):</strong> Verarbeitung von Daten, die erforderlich sind, um Ihnen unsere Dienste (z. B. In-App-Käufe, Account-Management) bereitzustellen.</li>
                <li><strong>Einwilligung (Art. 6 Abs. 1 lit. a DSGVO):</strong> Für personalisierte Werbung über Google AdMob und die Verwendung von Google Firebase Analytics bitten wir vorab um Ihre ausdrückliche Einwilligung.</li>
                <li><strong>Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO):</strong> Datenverarbeitung zur Verbesserung unserer App und zur Sicherstellung ihrer Sicherheit.</li>
            </ul>
            <p>Sie können Ihre Einwilligung jederzeit widerrufen, indem Sie uns kontaktieren oder die entsprechenden Einstellungen in Ihrer App oder Ihrem Gerät ändern.</p>
        </section>
    
        <section>
            <h2>5. Werbung und Drittanbieter (Google AdMob, Google Firebase)</h2>
            <p>Unsere App verwendet <strong>Google AdMob</strong> zur Bereitstellung von Werbung und <strong>Google Firebase</strong> für Analytics und das Account-Management. Google AdMob kann Daten wie die Advertising ID und Standortinformationen sammeln, während Firebase Nutzerdaten für Analytics und Account-Erstellung verwenden kann.</p>
            <p>Wenn Sie personalisierte Werbung deaktivieren möchten, können Sie dies in den Einstellungen Ihres Geräts tun:</p>
            <ul>
                <li><strong>Android:</strong> Einstellungen &gt; Google &gt; Anzeigen &gt; "Personalisierte Werbung deaktivieren".</li>
                <li><strong>iOS:</strong> Einstellungen &gt; Datenschutz &gt; Werbung &gt; "Ad-Tracking beschränken".</li>
            </ul>
            <p>Weitere Informationen finden Sie in der <a href="https://policies.google.com/privacy" target="_blank">Google-Datenschutzrichtlinie</a>.</p>
        </section>
        <section>
            <h2>6. Cookies und ähnliche Technologien</h2>
            <p>Unsere App verwendet keine Cookies direkt. Allerdings können durch eingebundene Drittanbieter wie Google AdMob, Google Firebase und Analyse-Tools Cookies oder ähnliche Technologien (z. B. SDKs) eingesetzt werden. Diese Technologien werden verwendet, um:</p>
            <ul>
                <li>Werbung anzuzeigen (Google AdMob).</li>
                <li>Nutzeraktivitäten anonym zu analysieren und die App zu verbessern (Google Firebase Analytics).</li>
                <li>Account-Management über Firebase zu ermöglichen.</li>
            </ul>
            <p>Beim ersten Start unserer App werden Sie gefragt, ob Sie der Verwendung dieser Technologien zustimmen. Sie können Ihre Einwilligung jederzeit in den Einstellungen der App widerrufen oder anpassen.</p>
        </section>
        <section>
            <h2>7. Aufbewahrungsfristen</h2>
            <p>Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die Erfüllung der jeweiligen Zwecke erforderlich ist oder wir gesetzlich dazu verpflichtet sind.</p>
            <p>Beispiele für Aufbewahrungsfristen:</p>
            <ul>
                <li><strong>In-App-Kaufdaten:</strong> Wir speichern Daten über abgeschlossene Käufe für die Dauer gesetzlicher Aufbewahrungsfristen (z. B. steuerliche Nachweispflichten von 10 Jahren).</li>
                <li><strong>Werbedaten:</strong> Daten, die für personalisierte Werbung erhoben werden, werden gemäß den Richtlinien von Google AdMob gespeichert.</li>
                <li><strong>Analyse- und Nutzungsdaten:</strong> Diese werden anonymisiert gespeichert und nur für statistische Auswertungen genutzt.</li>
            </ul>
        </section>
        <section>
            <h2>8. Rechte der Nutzer</h2>
            <h3>8.1 Rechte gemäß DSGVO</h3>
            <p>Wenn Sie in der EU ansässig sind, haben Sie folgende Rechte:</p>
            <ul>
                <li><strong>Recht auf Auskunft:</strong> Sie können eine Kopie Ihrer gespeicherten Daten anfordern.</li>
                <li><strong>Recht auf Berichtigung:</strong> Sie können unrichtige oder unvollständige Daten korrigieren lassen.</li>
                <li><strong>Recht auf Löschung:</strong> Sie können verlangen, dass Ihre Daten gelöscht werden.</li>
                <li><strong>Recht auf Einschränkung der Verarbeitung:</strong> Sie können die Verarbeitung Ihrer Daten einschränken lassen.</li>
                <li><strong>Recht auf Widerspruch:</strong> Sie können der Nutzung Ihrer Daten für bestimmte Zwecke widersprechen.</li>
            </ul>
        </section>
        <section>
            <h2>9. Beschwerderecht bei einer Aufsichtsbehörde</h2>
            <p>Falls Sie der Meinung sind, dass die Verarbeitung Ihrer Daten gegen die DSGVO verstößt, haben Sie das Recht, eine Beschwerde bei einer Datenschutzbehörde einzureichen. Für Deutschland ist die zuständige Aufsichtsbehörde:</p>
           
               <p>  Der Bundesbeauftragte für den Datenschutz und die Informationsfreiheit (BfDI)</p>
                <p> Husarenstraße 30</p>
                <p>53117 Bonn</p>
                <p>Telefon: +49 (0)228 997799-0</p>
                Webseite: <a href="https://www.bfdi.bund.de" target="_blank">https://www.bfdi.bund.de</a>
           
        </section>
        <section>
            <h2>10. Änderungen der Datenschutzrichtlinie</h2>
            <p>Wir behalten uns das Recht vor, diese Datenschutzrichtlinie zu aktualisieren. Änderungen werden hier veröffentlicht, und das Datum der letzten Aktualisierung wird entsprechend angepasst.</p>
        </section>
        <section>
            <h2>11. Kontakt</h2>
            <p>Bei Fragen oder Anliegen können Sie uns jederzeit unter folgender Adresse kontaktieren:</p>
            <p><strong>E-Mail:</strong> <a href="mailto:info@finnmikoschek.de">info@finnmikoschek.de</a></p>
        </section></div>);
    }

     const CosmicTapEN = () => {
      return (<div>
    
        <h2>1. Introduction</h2>
            <p>This Privacy Policy describes how CosmicTap collects, uses, processes, and protects data collected during your use of our mobile app. We are committed to protecting your privacy and complying with relevant data protection laws, including:</p>
            <ul>
                <li><strong>EU:</strong> General Data Protection Regulation (GDPR).</li>
                <li><strong>Germany:</strong> Federal Data Protection Act (BDSG) and Telecommunication-Telemedia Data Protection Act (TTDSG).</li>
                <li><strong>USA:</strong> California Consumer Privacy Act (CCPA).</li>
                <li><strong>Brazil:</strong> Lei Geral de Proteção de Dados (LGPD).</li>
                <li><strong>Canada:</strong> Personal Information Protection and Electronic Documents Act (PIPEDA).</li>
                <li><strong>United Kingdom:</strong> UK GDPR and Data Protection Act 2018.</li>
            </ul>
            <p>Depending on your location, additional specific regulations may apply, as outlined in this policy.</p>
       
     
            <h2>2. Data Controller</h2>
            <p>The data controller responsible for the processing of data is:</p>
            <p>
                Finn Mikoschek
                info@finnmikoschek.de
            </p>
        
     
            <h2>3. What Data Do We Collect?</h2>
            <p>We collect data to provide you with our services, improve the app, and meet legal requirements. This includes:</p>
            <h3>3.1 Automatically Collected Data:</h3>
            <ul>
                <li><strong>Device Information:</strong> Device type, operating system, device model, unique device identifiers (e.g., Advertising ID).</li>
                <li><strong>Usage Data:</strong> Interactions with the app, session duration, error, and crash reports.</li>
            </ul>
            <h3>3.2 Data from Third Parties:</h3>
            <p>We use third-party services such as Google AdMob (advertising), Google Firebase (for account management and analytics), and payment platforms (Google Play Store/Apple App Store), which may collect additional data, including:</p>
            <ul>
                <li>Location data (for personalized advertising).</li>
                <li>Payment data (such as purchase confirmations processed solely by the stores).</li>
                <li><strong>Account Data:</strong> Email addresses for account creation through Firebase, if users wish to store their account in the cloud.</li>
            </ul>

            <h2>4. Legal Basis for Data Processing</h2>
            <p>We process personal data under the following legal bases:</p>
            <ul>
                <li><strong>Contract Performance (Art. 6(1)(b) GDPR):</strong> Processing data necessary to provide our services (e.g., in-app purchases, account management).</li>
                <li><strong>Consent (Art. 6(1)(a) GDPR):</strong> We seek your explicit consent for personalized advertising via Google AdMob and for using Google Firebase Analytics.</li>
                <li><strong>Legitimate Interest (Art. 6(1)(f) GDPR):</strong> Data processing to improve our app and ensure its security.</li>
                <li><strong>CCPA (USA):</strong> Data processing to provide services under California privacy laws.</li>
                <li><strong>LGPD (Brazil):</strong> Data processing in compliance with Brazilian privacy laws.</li>
            </ul>
            <p>You can withdraw your consent at any time by contacting us or changing the settings in your app or device.</p>

            <h2>5. Advertising and Third Parties (Google AdMob, Google Firebase)</h2>
            <p>Our app uses <strong>Google AdMob</strong> for advertising and <strong>Google Firebase</strong> for analytics and account management. Google AdMob may collect data like Advertising ID and location information, while Firebase can use user data for analytics and account creation.</p>
            <p>If you wish to disable personalized advertising, you can do so in your device settings:</p>
            <ul>
                <li><strong>Android:</strong> Settings &gt; Google &gt; Ads &gt; "Opt out of Ads Personalization".</li>
                <li><strong>iOS:</strong> Settings &gt; Privacy &gt; Advertising &gt; "Limit Ad Tracking".</li>
            </ul>
            <p>For more information, please see the <a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a>.</p>
  
 
    
            <h2>6. Cookies and Similar Technologies</h2>
            <p>Our app does not use cookies directly. However, third-party services like Google AdMob, Google Firebase, and analytics tools might deploy cookies or similar technologies (e.g., SDKs) to:</p>
            <ul>
                <li>Display advertisements (Google AdMob).</li>
                <li>Anonymously analyze user activities and improve the app (Google Firebase Analytics).</li>
                <li>Manage accounts through Firebase.</li>
            </ul>
            <p>Upon first launching our app, you will be asked if you consent to the use of these technologies. You can withdraw or adjust your consent at any time through the app settings.</p>
  
            <h2>7. Country-Specific Requirements</h2>
            <h3>7.1 European Union (EU) and Germany</h3>
            <p>In the EU and Germany, you have the following rights under the GDPR:</p>
            <ul>
                <li>The right to access, rectify, delete, and restrict the processing of your data.</li>
                <li>The right to object to the processing of your data.</li>
                <li>The right to data portability.</li>
                <li>The right to lodge a complaint with a supervisory authority.</li>
            </ul>
            <h3>7.2 USA (CCPA)</h3>
            <p>If you are a California resident, you have the following additional rights:</p>
            <ul>
                <li>The right to know what personal data is collected about you.</li>
                <li>The right to opt out of the sharing or sale of your data ("Do Not Sell My Personal Information").</li>
                <li>The right to request the deletion of your data.</li>
            </ul>
            <h3>7.3 Brazil (LGPD)</h3>
            <p>Brazilian users have the right to:</p>
            <ul>
                <li>Access information about their data processing.</li>
                <li>Rectify or delete personal data.</li>
                <li>Revoke consent for data processing.</li>
            </ul>
            <h3>7.4 Canada (PIPEDA)</h3>
            <p>Canadian users can:</p>
            <ul>
                <li>Access the data collected about them.</li>
                <li>Restrict the use of their data or request its deletion.</li>
            </ul>
  
            <h2>8. Changes to This Privacy Policy</h2>
            <p>We reserve the right to update this Privacy Policy. Changes will be posted here, and the date of the last update will be adjusted accordingly.</p>
 
            <h2>9. Contact</h2>
            <p>If you have any questions or concerns, you can contact us at any time at the following address:</p>
            <p><strong>Email:</strong> <a href="mailto:info@finnmikoschek.de">info@finnmikoschek.de</a></p>
             
      </div>);
    }
    const VulpioDE = () => {
  return (
    <div>
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend
        informieren wir Sie darüber, wie personenbezogene Daten bei der Nutzung
        der App <strong>Vulpio</strong> verarbeitet werden. Die Verarbeitung
        erfolgt gemäß der Datenschutz-Grundverordnung (DSGVO).
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>Finn Mikoschek</p>
      <p>E-Mail: info@finnmikoschek.de</p>

      <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
      <p>
        Bei der Nutzung der App Vulpio können personenbezogene Daten verarbeitet
        werden. Dies erfolgt ausschließlich, soweit dies für den Betrieb der App,
        zur Verbesserung der Funktionen oder zur Abwicklung von Zahlungen
        erforderlich ist.
      </p>

      <h3>2.1 Registrierung und Anmeldung</h3>
      <p>
        Nutzer können sich optional über E-Mail, Apple, Google oder als Gast
        registrieren und anmelden. Bei einer Registrierung werden die zur
        Authentifizierung erforderlichen Daten über Firebase Authentication
        verarbeitet, insbesondere eine E-Mail-Adresse oder eine vom jeweiligen
        Anbieter bereitgestellte Benutzer-ID.
      </p>

      <h3>2.2 Nutzungs- und Analysedaten</h3>
      <p>
        Die App verwendet Google Firebase Analytics, um anonyme Informationen
        über die Nutzung der App zu erfassen. Dazu gehören unter anderem
        Geräteinformationen, App-Interaktionen, Sitzungsdauer sowie technische
        Fehlerberichte. Diese Daten dienen ausschließlich der Verbesserung der
        App.
      </p>

      <h2>3. Werbung</h2>
      <p>
        Die App verwendet Google AdMob zur Anzeige von Werbung. Dabei können
        gerätebezogene Informationen wie die Advertising ID verarbeitet werden.
        Die Anzeige personalisierter Werbung erfolgt nur, sofern eine
        entsprechende Einwilligung vorliegt.
      </p>
      <p>
        Weitere Informationen zur Datenverarbeitung durch Google finden Sie in
        der Google-Datenschutzerklärung:
        https://policies.google.com/privacy
      </p>

      <h2>4. In-App-Käufe und Abonnements</h2>
      <p>
        In der App können optionale In-App-Käufe und Abonnements für Premium-
        Funktionen abgeschlossen werden. Die Zahlungsabwicklung erfolgt
        ausschließlich über den Apple App Store oder Google Play Store. Wir
        erhalten keine Zahlungsdaten oder Kreditkarteninformationen.
      </p>

      <h2>5. Rechtsgrundlagen der Verarbeitung</h2>
      <ul>
        <li>Art. 6 Abs. 1 lit. a DSGVO – Einwilligung</li>
        <li>Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung</li>
        <li>Art. 6 Abs. 1 lit. f DSGVO – Berechtigtes Interesse</li>
      </ul>

      <h2>6. Datenübermittlung in Drittländer</h2>
      <p>
        Durch die Nutzung von Google Firebase und Google AdMob kann eine
        Übermittlung von Daten in Drittländer, insbesondere in die USA,
        stattfinden. Die Übermittlung erfolgt auf Grundlage der von Google
        verwendeten Standardvertragsklauseln.
      </p>

      <h2>7. Speicherdauer</h2>
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie dies für die
        genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten
        bestehen.
      </p>

      <h2>8. Rechte der Nutzer</h2>
      <p>Sie haben gemäß DSGVO folgende Rechte:</p>
      <ul>
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
      </ul>

      <h2>9. Kontakt</h2>
      <p>
        Bei Fragen zum Datenschutz können Sie uns jederzeit unter folgender
        Adresse kontaktieren:
      </p>
      <p>E-Mail: info@finnmikoschek.de</p>

      <h2>10. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an
        rechtliche Anforderungen oder Änderungen der App anzupassen.
      </p>
    </div>
  );
};


const VulpioEN = () => {
  return (
    <div>
      <p>
        Protecting your personal data is important to us. This privacy policy
        explains how personal data is processed when using the app
        <strong> Vulpio</strong>, in accordance with the General Data Protection
        Regulation (GDPR).
      </p>

      <h2>1. Controller</h2>
      <p>Finn Mikoschek</p>
      <p>Email: info@finnmikoschek.de</p>

      <h2>2. Collection and Processing of Personal Data</h2>
      <p>
        When using the Vulpio app, personal data may be processed only to the
        extent necessary for operating the app, improving its functionality, or
        handling purchases.
      </p>

      <h3>2.1 Registration and Login</h3>
      <p>
        Users may optionally register or log in via email, Apple, Google, or as
        a guest. Authentication data is processed via Firebase Authentication,
        including email addresses or user IDs provided by the respective
        provider.
      </p>

      <h3>2.2 Usage and Analytics Data</h3>
      <p>
        The app uses Google Firebase Analytics to collect anonymized information
        about app usage, such as device information, interactions, session
        duration, and crash reports. This data is used solely to improve the app.
      </p>

      <h2>3. Advertising</h2>
      <p>
        The app uses Google AdMob to display advertisements. Device-related
        information such as the advertising ID may be processed. Personalized
        ads are shown only if user consent has been given.
      </p>
      <p>
        More information about Google’s data processing can be found at:
        https://policies.google.com/privacy
      </p>

      <h2>4. In-App Purchases and Subscriptions</h2>
      <p>
        Optional in-app purchases and premium subscriptions are available. All
        payments are processed exclusively through the Apple App Store or Google
        Play Store. We do not receive any payment or credit card information.
      </p>

      <h2>5. Legal Basis for Processing</h2>
      <ul>
        <li>Art. 6(1)(a) GDPR – Consent</li>
        <li>Art. 6(1)(b) GDPR – Performance of a contract</li>
        <li>Art. 6(1)(f) GDPR – Legitimate interest</li>
      </ul>

      <h2>6. Data Transfers to Third Countries</h2>
      <p>
        The use of Google Firebase and Google AdMob may involve data transfers to
        third countries, particularly the United States. Such transfers are
        based on standard contractual clauses provided by Google.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        Personal data is stored only for as long as necessary for the stated
        purposes or as required by legal obligations.
      </p>

      <h2>8. User Rights</h2>
      <p>Under the GDPR, users have the following rights:</p>
      <ul>
        <li>Right of access (Art. 15 GDPR)</li>
        <li>Right to rectification (Art. 16 GDPR)</li>
        <li>Right to erasure (Art. 17 GDPR)</li>
        <li>Right to restriction of processing (Art. 18 GDPR)</li>
        <li>Right to data portability (Art. 20 GDPR)</li>
        <li>Right to object (Art. 21 GDPR)</li>
      </ul>

      <h2>9. Contact</h2>
      <p>
        If you have any questions regarding data protection, please contact us
        at:
      </p>
      <p>Email: info@finnmikoschek.de</p>

      <h2>10. Changes to this Privacy Policy</h2>
      <p>
        We reserve the right to update this privacy policy to reflect legal
        changes or modifications to the app.
      </p>
    </div>
  );
};

    return(
        <div><Sidebar onLanguageChange={LanguageChange}/>
                <div class="App-header">
            <div class="img_header">
                <h1 id='topic_header'></h1>
                <p id='text_header'></p>
                <img src="/images/web_app_header.webp"></img></div>
            <div class="text_container" id="service-container">
            
            <div class="text_container_data">
            <WhichPP />
                </div>
                </div>
            </div>
        </div>

    );

}

export default PrivacyPolicy;